import script from "./transportContractDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./transportContractDetail.vue?vue&type=script&setup=true&lang=js"

import "./transportContractDetail.vue?vue&type=style&index=0&id=4691219a&lang=less"

const __exports__ = script;

export default __exports__